import React, {useState} from 'react'
import 'bootstrap-icons/font/bootstrap-icons.css';
import { Container, Row, Col, Carousel, Nav, Card, Badge } from 'react-bootstrap';
import img1 from '../Components/Images/Retail weighing/D900/4.png'
import img2 from '../Components/Images/Retail weighing/D900/5.png'


function Dibalwind() {

  const featureIcons = [
    { icon: "printer", text: "1 PRINTER RECEIPTS OR LABELS" },
    { icon: "printer-fill", text: "EASY LOADING RECEIPT PRINTER" },
    { icon: "vinyl", text: "LINERLESS DEP ON MODEL" },
    { icon: "display", text: "SEGMENTS LCD DISPLAY" },
    { icon: "display-fill", text: "GRAPHIC LCD DISPLAY (optional)" },
    { icon: "download", text: "UP TO 10,000 PLUs" },
    { icon: "people-fill", text: "UP TO 20 VENDORS" },
    { icon: "ethernet", text: "ETHERNET TCP/IP" },
    { icon: "usb-drive", text: "USB OPTIONAL" },
    { icon: "wifi", text: "Wi-Fi OPTIONAL" },
    { icon: "battery-charging", text: "INTERNAL RECHARGEABLE BATTERY (opt.)" },
  ];

  const [activeTab, setActiveTab] = useState('MODELS');
  
  // Define a constant for the active blue color
  const activeColor = '#2e5177';
  const inactiveColor = '#9E9E9E';
  
  // Tabs with their default colors - we'll override these based on which tab is active
  const tabs = [
    { id: 'MODELS', defaultColor: activeColor },
    { id: 'INFORMATION', defaultColor: inactiveColor },
  ];
  
  // Function to get the current color for a tab
  const getTabColor = (tabId) => {
    // When a tab is active, always use the active blue color
    // When inactive, use the inactive gray color
    return tabId === activeTab ? activeColor : inactiveColor;
  };
  
  const products = [
    {
      id: 1,
      image: img1,
      title: "ELECTRONIC SCALES W-025 FLAT LABELS",
      description: "Electronic scales in flat format with labels printer(also suitable for receipts",
      isNew: false
    },
    {
      id: 2,
      image: img2,
      title: "Electronic scales in pole format with labels printer(also suitable for receipts)",
      description: "",
      isNew: false
    }
    
  ];

  // Information section bullet points
  const informationPoints = [
    "Extensive information for each PLU: normal price and offer price, price for weight scales and by kg/100 g, 3 names of 20 characters or 2 names of 30 characters, 20 free texts of 24 characters, 1 text of 3,072 characters, etc.",
    "PLU search by code or name.",
    "Preset keys to programming menus: to change prices, register PLUs or vendors, etc.",
    "Direct access to 999 PLUs from the keyboard.",
    "Drill down menus.",
    "Printing of the scale menus.",
    "Programmable macros: recording of a sequence of keys to create direct access to any task (reopening of receipt, lists, change in batcher number, etc.).",
    "Sales and management reports: sales (by article, vendor, time frames, last month, etc.), margins, balance available in the cash drawer, modified PLUs, etc.",
    "Fast and reliable communication between scales, with PC and mobile devices (via DWS).",
    "Stocks management on the scale.",
    "Stock / order mode.",
    "10 types of generic traceability (for meat, fish, fruit, vegetables, etc.) up to 99 products. Included in the prevailing European legislation on bovine traceability.",
  ];

  // Function to render content based on active tab
  const renderTabContent = () => {
    switch(activeTab) {
      case 'MODELS':
        return (
          <Row className="g-4">
            {products.map((product) => (
              <Col key={product.id} md={6} lg={4}>
                <Card className="h-100 border-0 shadow-sm">
                  <div className="position-relative">
                    <Card.Img variant="top" src={product.image} alt={product.title} className='p-5'/>
                    {product.isNew && (
                      <Badge 
                        className="position-absolute top-0 end-0 m-2 px-3 py-2" 
                        bg="primary"
                      >
                        NEW
                      </Badge>
                    )}
                  </div>
                  <Card.Body className="text-center">
                    <Card.Title className="fw-bold"
                    style={{fontFamily: "'Roboto Slab', serif", fontSize:"14px"}}
                    >{product.title}</Card.Title>
                    <Card.Text className="text-muted mt-2"
                    style={{fontFamily: "'Poppins', serif", fontSize:"12px"}}
                    >
                      {product.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );
      case 'INFORMATION':
        return (
          <div className="p-4">
            <h4 style={{fontFamily: "'Montserrat', serif", marginBottom: "20px"}}>Main Characteristic</h4>
            <ul className="information-list">
              {informationPoints.map((point, index) => (
                <li key={index} style={{fontFamily: "'Poppins', serif", fontSize: "14px", marginBottom: "15px"}}>
                  {point}
                </li>
              ))}
            </ul>
          </div>
        );
      default:
        return null;
    }
  };

  return (
    <div>
      <div className='text-center'>
        <h2 style={{fontFamily: "'Montserrat', serif"}}>Retail Scales Wind Series</h2>
        <p className='ml-5 mr-5 mt-4' style={{fontFamily: "'Poppins', serif", fontSize:"14px"}}>Price computing electronic scales with label printer and PC connection. High performance and easy to use scales.</p>
      </div>
      
      <Container className="my-5">
        <Row>
          {/* Left Division - Image Carousel */}
          <Col md={6} className="mb-4 mb-md-0">
            <div className="border rounded p-3 h-100">
              <Carousel>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img1}
                    alt="First slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>First slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                <Carousel.Item>
                  <img
                    className="d-block w-100"
                    src={img2}
                    alt="Second slide"
                  />
                  {/* <Carousel.Caption>
                    <h5>Second slide</h5>
                    <p>Sample carousel caption text</p>
                  </Carousel.Caption> */}
                </Carousel.Item>
                
                
              </Carousel>
            </div>
          </Col>

          {/* Right Division - Icons Display */}
          <Col md={6}>
            <div className="border rounded p-3 h-100">
              <h4 className="mb-3">Features</h4>
              <Row className="g-3">
                {featureIcons.map((item, index) => (
                  <Col xs={4} key={index} className="text-center mb-3">
                    <div className=" mx-auto mb-2">
                      <i className={`bi bi-${item.icon}`}
                      style={{fontSize:"30px"}}
                      ></i>
                    </div>
                    <p className="small-text mb-0"
                    style={{fontSize:"10px"}}
                    >{item.text}</p>
                  </Col>
                ))}
              </Row>
            </div>
          </Col>
        </Row>
      </Container>

      <Container fluid className="p-0">
        {/* Custom Tabs */}
        <div className="position-relative">
          <Nav className="custom-tabs d-flex">
            {tabs.map((tab) => (
              <Nav.Item 
                key={tab.id} 
                className="tab-item" 
                style={{ 
                  backgroundColor: getTabColor(tab.id)
                }}
                onClick={() => setActiveTab(tab.id)}
              >
                <Nav.Link 
                  className={`py-3 px-4 text-white fw-bold border-0 ${activeTab === tab.id ? 'active' : ''}`}
                >
                  {tab.id}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        {/* Tab Content Area */}
        <div className="bg-white p-4 border">
          {renderTabContent()}
        </div>

        {/* Custom CSS */}
        <style>{`
          .custom-tabs {
            display: flex;
            overflow-x: auto;
            position: relative;
          }

          .tab-item {
            position: relative;
            /* This creates a shape with straight left edge and slanted right edge */
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
            margin-right: -20px; /* Negative margin creates the overlap effect */
            z-index: 1;
            cursor: pointer;
            transition: background-color 0.3s ease;
          }

          /* Each subsequent tab needs higher z-index to properly overlap */
          .tab-item:nth-child(1) { z-index: 5; }
          .tab-item:nth-child(2) { z-index: 4; }
          .tab-item:nth-child(3) { z-index: 3; }
          .tab-item:nth-child(4) { z-index: 2; }
          .tab-item:nth-child(5) { z-index: 1; }

          /* Last tab can have a different shape if needed */
          .tab-item:last-child {
            margin-right: 0;
            clip-path: polygon(0 0, 85% 0, 100% 100%, 0% 100%);
          }

          .tab-item .nav-link {
            background: transparent !important;
            border-radius: 0;
            padding: 15px 40px; /* Adjust padding as needed */
          }

          .tab-item .nav-link.active {
            font-weight: bold;
          }

          .information-list {
            padding-left: 25px;
          }
          
          .information-list li {
            position: relative;
            list-style-type: none;
            padding-left: 25px;
            margin-bottom: 15px;
          }
          
          .information-list li:before {
            content: "•";
            position: absolute;
            left: 0;
            color: #2e5177;
            font-size: 24px;
            line-height: 1;
          }
          
          .circular-icon {
            width: 80px;
            height: 80px;
            border-radius: 50%;
            background-color: #f8f9fa;
            border: 2px solid #0d6efd;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        `}</style>
      </Container>
    </div>
  )
}

export default Dibalwind
